module.exports = __webpack_public_path__ + "img/new-real-estate-3.e85bdaa6.jpg";